module.exports = __webpack_public_path__ + "img/cuve_cylindrique1_checkbox.ab23d1be.png";